/* =========================================================
   Request a Call Back — Form Handler
   File: assets/request-call-back.js
   Reference: ContactFormPopup script
   ========================================================= */

(function () {
  'use strict';

  /* ── Google Sheet endpoint ──────────────────────────────── */
  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyyM2NcczWLY9o4AyupcoBVHYNYhbJjiVeycrs_gT5eswlsJ1U1tf-kCemgIVfVtfZ9_w/exec';

  /* ── Boot ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', initRCB);

  function initRCB() {
    var form      = document.getElementById('rcbForm');
    var submitBtn = document.getElementById('rcbSubmitBtn');
    var thankyou  = document.getElementById('rcbThankyou');

    if (!form) return;

    /* Store original button label */
    var btnTextEl = submitBtn.querySelector('.rcb-btn-text');
    submitBtn.setAttribute(
      'data-label',
      btnTextEl ? btnTextEl.textContent.trim() : 'REQUEST PRICING'
    );

    /* Fill UTM fields on load */
    fillUTMFields(form);

    /* Live clear field errors on input */
    form.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('input', function () {
        clearFieldError(input);
        clearApiError(form);
      });
    });

    /* Submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearAllErrors(form);

      var data = collectData(form);

      if (!validate(data, form)) {
        showApiError(form, '❌ Please fill in all required fields correctly.');
        return;
      }

      submitForm(data, form, submitBtn, thankyou);
    });
  }

  /* ── Collect field values ───────────────────────────────── */
  function collectData(form) {
    return {
      Company: form.querySelector('#rcb_company').value.trim(),
      Name:    form.querySelector('#rcb_name').value.trim(),
      Email:   form.querySelector('#rcb_email').value.trim(),
      Mobile:  form.querySelector('#rcb_mobile').value.trim(),
      Product: form.querySelector('#rcb_product').value.trim(),
      City:    form.querySelector('#rcb_city').value.trim()
    };
  }

  /* ── UTM / GCLID fill ───────────────────────────────────── */
  function getUTM() {
    var p = new URLSearchParams(window.location.search);
    return {
      utm_source:   p.get('utm_source')   ? '- ' + p.get('utm_source')   : '- utm_source',
      utm_medium:   p.get('utm_medium')   ? '- ' + p.get('utm_medium')   : '- utm_medium',
      utm_campaign: p.get('utm_campaign') ? '- ' + p.get('utm_campaign') : '- utm_campaign',
      gclid:        p.get('gclid')        ? '- ' + p.get('gclid')        : '- gclid'
    };
  }

  function fillUTMFields(form) {
    var utm = getUTM();
    Object.keys(utm).forEach(function (key) {
      var el = form.querySelector('input[name="' + key + '"]');
      if (el) el.value = utm[key];
    });
    var msg = form.querySelector('input[name="Message"]');
    if (msg) msg.value = 'Enquiry from website';
  }

  /* ── Validation ─────────────────────────────────────────── */
  function validate(data, form) {
    var ok = true;

    if (!data.Company) { showFieldError(form.querySelector('#rcb_company')); ok = false; }
    if (!data.Name)    { showFieldError(form.querySelector('#rcb_name'));    ok = false; }
    if (!data.Product) { showFieldError(form.querySelector('#rcb_product')); ok = false; }
    if (!data.City)    { showFieldError(form.querySelector('#rcb_city'));    ok = false; }

    /* Email */
    if (!data.Email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.Email)) {
      showFieldError(form.querySelector('#rcb_email'));
      ok = false;
    }

    /* Mobile: 10 digit Indian number starting with 6-9 */
    if (!data.Mobile || !/^[6-9][0-9]{9}$/.test(data.Mobile)) {
      showFieldError(form.querySelector('#rcb_mobile'));
      ok = false;
    }

    return ok;
  }

  /* ── API Call ────────────────────────────────────────────── */
  function submitForm(data, form, btn, thankyou) {
    setLoading(btn, true);

    var utm = getUTM();

    // ── Send to Google Sheet ──────────────
    fetch(SHEET_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        formName : 'RequestCallBack',
        company  : data.Company,
        name     : data.Name,
        email    : data.Email,
        mobile   : '+91' + data.Mobile,
        product  : data.Product,
        city     : data.City,
        utm_source   : utm.utm_source,
        utm_medium   : utm.utm_medium,
        utm_campaign : utm.utm_campaign,
        gclid        : utm.gclid
      })
    })
      .then(function () {
        setLoading(btn, false);
        form.reset();
        fillUTMFields(form);
        onSuccess(form, thankyou);
      })
      .catch(function (err) {
        console.error('[RCB] Submit Error:', err);
        setLoading(btn, false);
        showApiError(form, '❌ Something went wrong. Please try again.');
      });
  }

  /* ── Success: hide form, show Thank You in same place ───── */
  function onSuccess(form, thankyou) {
    /* Hide form */
    form.style.display = 'none';

    if (!thankyou) return;

    /* Show thank you */
    thankyou.style.display = 'block';

    /* Remove old back button if exists (prevent duplicates) */
    var old = thankyou.querySelector('.rcb-thankyou-back');
    if (old) old.remove();

    /* Add "Submit Another" button */
    var backBtn         = document.createElement('button');
    backBtn.type        = 'button';
    backBtn.className   = 'rcb-thankyou-back';
    backBtn.textContent = 'Submit Another Enquiry';

    backBtn.addEventListener('click', function () {
      thankyou.style.display = 'none';
      form.style.display     = '';
      form.reset();
      fillUTMFields(form);
      clearAllErrors(form);
    });

    thankyou.appendChild(backBtn);
  }

  /* ── Field Error Helpers ────────────────────────────────── */
  function showFieldError(input) {
    if (!input) return;
    input.classList.add('rcb-input-error');
    var err = document.querySelector('.rcb-error[data-for="' + input.id + '"]');
    if (err) err.textContent = getErrorMsg(input);
  }

  function clearFieldError(input) {
    if (!input) return;
    input.classList.remove('rcb-input-error');
    var err = document.querySelector('.rcb-error[data-for="' + input.id + '"]');
    if (err) err.textContent = '';
  }

  function clearAllErrors(form) {
    form.querySelectorAll('.rcb-input-error').forEach(function (el) {
      el.classList.remove('rcb-input-error');
    });
    form.querySelectorAll('.rcb-error').forEach(function (el) {
      el.textContent = '';
    });
    clearApiError(form);
  }

  function getErrorMsg(input) {
    var msgs = {
      rcb_company: 'Company name is required.',
      rcb_name:    'Your name is required.',
      rcb_email:   'Enter a valid email address.',
      rcb_mobile:  'Enter a valid 10-digit mobile number.',
      rcb_product: 'Product interest is required.',
      rcb_city:    'City is required.'
    };
    return msgs[input.id] || 'This field is required.';
  }

  /* ── API Error (bottom of form) ─────────────────────────── */
  function showApiError(form, message) {
    var el = form.querySelector('#rcbToast');
    if (!el) return;
    el.textContent = message;
    el.className   = 'rcb-toast rcb-toast--error';
  }

  function clearApiError(form) {
    var el = form.querySelector('#rcbToast');
    if (!el) return;
    el.textContent = '';
    el.className   = 'rcb-toast';
  }

  /* ── Button Loading State ───────────────────────────────── */
  function setLoading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('rcb-loading', on);
    var textEl = btn.querySelector('.rcb-btn-text');
    if (textEl) {
      textEl.textContent = on
        ? 'Submitting…'
        : (btn.getAttribute('data-label') || 'REQUEST PRICING');
    }
  }

})();